// extracted by mini-css-extract-plugin
export default {"socialLink":"SocialLink-module__socialLink___fnhA3"};